(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ── Refs ── */
  var drawer   = document.getElementById('cart-drawer');
  var bodyEl   = drawer && drawer.querySelector('[data-drawer-body]');
  var footEl   = drawer && drawer.querySelector('[data-drawer-foot]');
  var countEl  = drawer && drawer.querySelector('[data-drawer-count]');
  if (!drawer) return;

  /* ── Money ── */
  var _fmt = null;
  function money(cents, currency) {
    if (!_fmt || _fmt._currency !== (currency || 'EUR')) {
      _fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' });
      _fmt._currency = currency || 'EUR';
    }
    return _fmt.format(cents / 100);
  }

  /* ── Open / close ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = drawer.querySelector('.cdrawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Cart icon in header → open drawer instead of navigating */
  var cartLink = document.querySelector('.site-header__cart-btn');
  if (cartLink) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  /* ── Fetch helpers ── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        updateHeaderBadge(cart.item_count);
        return cart;
      });
  }

  function updateCart(key, qty) {
    var updates = {};
    updates[key] = qty;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderDrawer(cart);
      updateHeaderBadge(cart.item_count);
      return cart;
    });
  }

  /* ── Render ── */
  function renderDrawer(cart) {
    /* Count badge in drawer header */
    if (countEl) {
      countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    }

    if (cart.item_count === 0) {
      bodyEl.innerHTML = renderEmpty();
      footEl.innerHTML = '';
      return;
    }

    bodyEl.innerHTML = '<ul class="cdrawer__items">' +
      cart.items.map(renderItem).join('') +
    '</ul>';
    footEl.innerHTML = renderFoot(cart);
  }

  function renderItem(item) {
    var imgHtml = item.featured_image && item.featured_image.url
      ? '<img src="' + item.featured_image.url.replace(/(\.\w+)$/, '_120x120$1') + '" alt="' + escHtml(item.product_title) + '" class="cdrawer__item-img" loading="lazy" width="80" height="80">'
      : '<div class="cdrawer__item-img-ph"></div>';

    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cdrawer__item-variant">' + escHtml(item.variant_title.replace(/ \/ /g, ' · ')) + '</p>'
      : '';

    return '<li class="cdrawer__item" data-item-key="' + item.key + '">' +
      '<div class="cdrawer__item-img-wrap">' + imgHtml + '</div>' +
      '<div class="cdrawer__item-details">' +
        '<a href="' + item.url + '" class="cdrawer__item-title">' + escHtml(item.product_title) + '</a>' +
        variantHtml +
        '<div class="cdrawer__item-controls">' +
          '<div class="cdrawer__qty">' +
            '<button class="cdrawer__qty-btn" aria-label="Menge verringern" data-qty-minus="' + item.key + '">' +
              '<span class="material-symbols-outlined" aria-hidden="true">remove</span>' +
            '</button>' +
            '<span class="cdrawer__qty-val">' + item.quantity + '</span>' +
            '<button class="cdrawer__qty-btn" aria-label="Menge erhöhen" data-qty-plus="' + item.key + '">' +
              '<span class="material-symbols-outlined" aria-hidden="true">add</span>' +
            '</button>' +
          '</div>' +
          '<span class="cdrawer__item-price">' + money(item.final_line_price, null) + '</span>' +
          '<button class="cdrawer__item-remove" aria-label="Entfernen" data-remove="' + item.key + '">' +
            '<span class="material-symbols-outlined" aria-hidden="true">delete_outline</span>' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function renderEmpty() {
    return '<div class="cdrawer__empty">' +
      '<span class="material-symbols-outlined cdrawer__empty-icon" aria-hidden="true">shopping_cart</span>' +
      '<p class="cdrawer__empty-title">Dein Warenkorb ist leer</p>' +
      '<p class="cdrawer__empty-text">Entdecke unsere refurbished Apple-Geräte.</p>' +
      '<a href="/" class="cdrawer__empty-link btn-primary">Weiter einkaufen</a>' +
    '</div>';
  }


  function renderFoot(cart) {
    return '<dl class="cdrawer__foot-lines">' +
      '<div class="cdrawer__foot-row"><dt>Zwischensumme</dt><dd>' + money(cart.items_subtotal_price, cart.currency) + '</dd></div>' +
      (cart.total_discount > 0 ? '<div class="cdrawer__foot-row"><dt>Ersparnis</dt><dd>−' + money(cart.total_discount, cart.currency) + '</dd></div>' : '') +
      '<div class="cdrawer__foot-row cdrawer__foot-row--shipping"><dt>Versand</dt><dd>Kostenlos</dd></div>' +
    '</dl>' +
    '<div class="cdrawer__foot-total"><span>Gesamt</span><span>' + money(cart.total_price, cart.currency) + '</span></div>' +
    '<a href="/cart" class="cdrawer__checkout-btn btn-primary">' +
      '<span class="material-symbols-outlined" aria-hidden="true">shopping_cart</span>' +
      'Zum Warenkorb' +
    '</a>';
  }

  /* ── Header badge ── */
  function updateHeaderBadge(count) {
    var badge = document.querySelector('.site-header__cart-badge');
    if (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
    var link = document.querySelector('.site-header__cart-btn');
    if (link) link.setAttribute('aria-label', 'Warenkorb' + (count > 0 ? ' (' + count + ')' : ''));
  }

  /* ── Event delegation inside drawer ── */
  drawer.addEventListener('click', function (e) {
    var minusBtn  = e.target.closest('[data-qty-minus]');
    var plusBtn   = e.target.closest('[data-qty-plus]');
    var removeBtn = e.target.closest('[data-remove]');

    if (minusBtn || plusBtn || removeBtn) {
      var key = (minusBtn || plusBtn || removeBtn).dataset.qtyMinus
             || (minusBtn || plusBtn || removeBtn).dataset.qtyPlus
             || (minusBtn || plusBtn || removeBtn).dataset.remove;
      var li = drawer.querySelector('[data-item-key="' + key + '"]');
      if (li) li.classList.add('is-loading');

      var currentQty = li ? parseInt(li.querySelector('.cdrawer__qty-val').textContent, 10) : 0;
      var newQty = removeBtn ? 0 : (plusBtn ? currentQty + 1 : Math.max(0, currentQty - 1));
      updateCart(key, newQty);
    }
  });

  /* ── Global add-to-cart interception ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    /* Only intercept product add-to-cart forms */
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var btnInner  = submitBtn && submitBtn.querySelector('[data-btn-text]');
    var origHTML  = submitBtn && submitBtn.innerHTML;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('mp__cart-btn--loading');
      if (btnInner) { btnInner.textContent = 'Wird hinzugefügt…'; }
      else if (submitBtn) { submitBtn.innerHTML = 'Wird hinzugefügt…'; }
    }

    var qty = form.querySelector('[name="quantity"]');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: parseInt(idInput.value, 10),
        quantity: qty ? parseInt(qty.value, 10) || 1 : 1
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetchCart();
    })
    .then(function () { openDrawer(); })
    .catch(function () { form.submit(); }) /* fallback: native submit */
    .finally(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('mp__cart-btn--loading');
        if (origHTML) submitBtn.innerHTML = origHTML;
      }
    });
  });

  /* ── Utility ── */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Init ── */
  fetchCart();

})();
  } catch(e) { console.error(e); }
})();

})();
